import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cycode = defineConnector({
  identifier: "cycode",
  name: "Cycode",
  tagLine: "Application security posture management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://(app|api)\\.cycode\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://api.cycode.com/api/v1/auth/api-token",
        method: "POST",
        jsonBody: {
          clientId: app.secret.clientId,
          secret: app.secret.clientSecret,
        },
        headers: [
          {
            name: "Accept",
            value: "application/json",
          },
        ],
      },
      extract: { from: "jsonPath", paths: ["token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create access tokens in Cycode",
      items: [
        {
          kind: "markdown",
          content:
            "In [Cycode](https://app.cycode.com/), go to **User settings → Access Tokens** and create a new access token. Cycode shows a client ID and client secret when the token is created.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://app.cycode.com/api/repositories?pageIndex=1&limit=1",
  },
});
